module.exports = __webpack_public_path__ + "img/app-store-dark.26df1255.svg";